
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Council } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class CouncilEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    council: Council;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCouncil()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCouncil(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.council = data;
                this.onDataChanged.next(this.council);
                resolve(this.council);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('council/' + this.routeParams.id).subscribe((res: Council ) => {
                    this.council = res;
                    this.onDataChanged.next(this.council);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(council): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('council/', council).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(council): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('council/', council).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(council): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('council/' + council.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): Council {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
